var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

InlineVariations.Models.Option = Backbone.Model.extend({});

module.exports = InlineVariations.Models.Option;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9pbmxpbmVfdmFyaWF0aW9ucy9mcm9udGVuZC9tb2RlbHMvb3B0aW9uLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2FrZXNoYXJpL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTY2MDg5ODI0OS00Mzk2L3Byb2R1Y3Rpb24tMjAxNy4wNS4yNF8yMS4xOS9kZWFsL21vZHVsZXMvaW5saW5lX3ZhcmlhdGlvbnMvZnJvbnRlbmQvbW9kZWxzL29wdGlvbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxnQkFBQSxxQ0FBbUIsTUFBTSxDQUFDLG1CQUFQLE1BQU0sQ0FBQyxtQkFBb0I7OztFQUM5QyxnQkFBZ0IsQ0FBQyxTQUFVOzs7QUFFM0IsZ0JBQWdCLENBQUMsTUFBTSxDQUFDLE1BQXhCLEdBQWlDLFFBQVEsQ0FBQyxLQUFLLENBQUMsTUFBZixDQUFzQixFQUF0Qjs7QUFFakMsTUFBTSxDQUFDLE9BQVAsR0FBaUIsZ0JBQWdCLENBQUMsTUFBTSxDQUFDIn0=
